import { render, staticRenderFns } from "./lkuConsolidaCoa.vue?vue&type=template&id=e5dc2690"
import script from "./lkuConsolidaCoa.vue?vue&type=script&lang=js"
export * from "./lkuConsolidaCoa.vue?vue&type=script&lang=js"
import style0 from "./lkuConsolidaCoa.vue?vue&type=style&index=0&id=e5dc2690&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports